<div class="container">
  <span class="returnButton" (click)="navigateBack()"
    >< License Batch Details</span
  >
  <app-header [title]="'Manage License Users'"></app-header>

  <div class="status-card" *ngIf="loading">
    Loading license batch details...
  </div>
  <div class="content" *ngIf="!loading && batch">
    <section class="details-card">
      <h2>{{ batchTitle }}</h2>
      <span class="batch-id">ID: {{ batchId }}</span>
      <div class="details-grid">
        <div>
          <span class="label">Company</span
          ><span class="value">{{ companyLabel }}</span>
        </div>
        <div>
          <span class="label">Batch Size</span
          ><span class="value">{{ batch.licenseBatchSize ?? 0 }}</span>
        </div>
        <div>
          <span class="label">Linked Users</span
          ><span class="value">{{ linkedUsersCount }}</span>
        </div>
        <div>
          <span class="label">Available Company Users</span
          ><span class="value">{{ availableUsersCount }}</span>
        </div>
      </div>
    </section>

    <section class="table-section">
      <h3>Linked Users</h3>
      <qs-table
        [data]="linkedUsersRows"
        [columns]="linkedColumns"
        [isSearchEnabled]="true"
        [isPaginatorEnabled]="true"
        [paginatorConfig]="paginatorConfig"
      ></qs-table>
    </section>
    <section class="table-section">
      <h3>Company Users (Unlinked)</h3>
      <div class="status-card" *ngIf="loadingCompanyUsers">
        Loading company users...
      </div>
      <qs-table
        *ngIf="!loadingCompanyUsers"
        [data]="availableUsersRows"
        [columns]="availableColumns"
        [isSearchEnabled]="true"
        [isPaginatorEnabled]="true"
        [paginatorConfig]="paginatorConfig"
      ></qs-table>
    </section>
  </div>
</div>
